<template>
  <div
    class="wbs-site__header-menu--responsivo nav--scroller bg-white box-shadow"
  >
    <nav class="nav nav-underline">
      <router-link
        :to="item.route"
        class="nav-link"
        v-for="(item, idx) in items"
        :key="idx"
      >
        <i class="mdi" :class="item.icon"></i>
        {{ item.text }}
      </router-link>
    </nav>
  </div>
</template>
<script>
export default {
  name: "appMenuBarraSuperior",
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>
<style lang="scss">
.wbs-site__header-menu--responsivo {
  position: fixed;
  left: 0;
  right: 0;
  height: 2.75rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
  margin-top: 40px;
  z-index: 4;
  @include themify($themes) {
    background-color: themed("headerMenuBackgroundColor");
  }
  &.nav--scroller {
    overflow-y: hidden;

    .nav {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      margin-top: -1px;
      overflow-x: auto;
      color: rgba(255, 255, 255, 0.75); //TODO: COLCAR EM VARAIVEIS
      text-align: center;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;

      .nav-link {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        font-size: 0.875rem;
        color: $page-text-color; //TODO: COLCAR EM VARAIVEIS

        &:hover {
          color: $green; //TODO: COLCAR EM VARAIVEIS
        }

        &.active {
          font-weight: 500;
          color: var(--gray-dark);
        }
      }
    }
  }
  @include media-breakpoint-up(md) {
    display: none;
  }
}
</style>
